import TemplateView from '../../../TemplateView'
import TumblerSwitch from '../../../components/TumblerSwitch'

export default class RequirementSwitcher extends TemplateView {

    constructor({
        label = "",
        value = "",
        onValueChange = "",
        disabled = false
    } = {}) {
        super();
        this.label = label;
        this.state = {
            value, onValueChange, disabled
        };
        this.onStatePropertyChanged("disabled", disabled => this.switcher.setState({readOnly: disabled}));
        this.onStatePropertyChanged("value", value => this.switcher.setState({enabled: value}));
    }

    templateHtml() {
        return `<label class='checkboxContainer requirementSwitcher'>
                    <span class='label passwordSettings_label'><%=label%></span>
                </label>`;
    }


    afterRender() {
        this.switcher = new TumblerSwitch({
            label: this.label,
            onSwitchCallback: this.state.onValueChange,
            additionalClass: "small"
        }).init(this.getEl());
        this.switcher.getEl().removeClass("components_switcher");

    }
}


// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/components/RequirementSwitcher.js